import watchUpdateNumberRange from './updateNumberRanges';
import watchSetRanges from './setRanges';

const watchMultieditNumberRanges = [watchUpdateNumberRange, watchSetRanges];

export default watchMultieditNumberRanges;
